import React from 'react'
import { FaCheck } from "react-icons/fa"
import { Link } from 'react-router-dom'
import { t } from 'i18next'
import i18n from '../i18'

export const About = () => {
  const language = i18n.language;

  return (
    <div className="px-6 md:px-20 py-16 bg-gradient-to-b from-gray-50 to-white">

      {/* Header */}
      <div className="text-center mb-14" data-aos="fade-up">
        <h2 className="text-4xl md:text-5xl font-extrabold text-indigo-900 drop-shadow-sm">
          {t('aboutus.heading1')}
        </h2>
        <p className="text-gray-600 mt-3 max-w-xl mx-auto text-[15px] md:text-base leading-7">
          {t('aboutus.heading2')}
        </p>
      </div>

      {/* New Card Layout */}
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">

        <div
          data-aos="zoom-in-up"
          className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 hover:shadow-2xl transition duration-300"
        >
          <div className="flex items-start gap-4">
            <div className="bg-indigo-900 p-3 rounded-full shadow-md">
              <FaCheck className="text-white" />
            </div>
            <p
              className={`text-gray-600 text-[15px] md:text-[16px] leading-[1.8] ${
                language === 'ar' || language === 'kr' ? 'text-right' : 'text-left'
              }`}
            >
              {t('aboutus.content1')}
            </p>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 hover:shadow-2xl transition duration-300"
        >
          <div className="flex items-start gap-4">
            <div className="bg-indigo-900 p-3 rounded-full shadow-md">
              <FaCheck className="text-white" />
            </div>
            <p
              className={`text-gray-600 text-[15px] md:text-[16px] leading-[1.8] ${
                language === 'ar' || language === 'kr' ? 'text-right' : 'text-left'
              }`}
            >
              {t('aboutus.content2')}
            </p>
          </div>
        </div>

      </div>

      {/* CTA */}
      <div className="text-center mt-16" data-aos="fade-up">
        <Link
          to="/about"
          className="inline-block bg-indigo-900 text-white py-3 px-10 rounded-full text-sm md:text-base tracking-wide shadow-md hover:bg-indigo-800 transition duration-300 active:scale-95"
        >
          {t('aboutus.heading1')}
        </Link>

        <div className="h-1 w-40 bg-indigo-900 mx-auto mt-6 rounded-full"></div>
      </div>
    </div>
  )
}